import axios from "axios";

export const http = axios.create({
  //baseURL: 'https://www.gbs-egis.com.br:3000/api/'
  //baseURL: "https://34.203.196.98/api/",
  baseURL: "https://egisnet.com.br/api/",
});
